<template>
    <div class="flex col-top" style="padding:20px;">
        <div style="margin-right: 20px">
            <div class="flex">
                <el-upload ref="upload" action="#" :http-request="loadImage" style="margin-left: 10px"
                    :show-file-list="false" accept=".jpg,.jpeg,.png">
                    <el-button size="mini" type="primary">上传图片</el-button>
                </el-upload>
                <el-select size="mini" style="margin-left: 10px" v-model="selectedFace" placeholder="选择定制面" multiple>
                    <el-option v-for="(item, index) in faceArr" :key="index" :label="item.N" :value="item.N">
                    </el-option>
                </el-select>
            </div>
            <canvas id="canvas-editor" style="border: 1px solid #d4d4d4;margin-top: 20px;padding:0;"></canvas>
        </div>
        <div class="flex-col col-top">
            <div v-loading="loading" :loading-text="loadingText"
                style="border: 1px solid #d4d4d4;width:500px;height:500px;overflow:hidden;background:#fff;position: relative;margin-top: 50px;">
                <canvas v-for="(item, index) in effectArr" :key="index" :id="`effectCanvas-${index}`"
                    style="transform-origin: left top" :style="{
                        'margin-left': `${item.left}px`,
                        'margin-top': `${item.top}px`,
                        transform: `scale(${item.scaleX}, ${item.scaleY})`,
                    }"></canvas>
            </div>
        </div>
    </div>
</template>
<script>


import { fabric } from "fabric";
import SmartObjectRenderer from '@/utils/SmartObject.js'
import { loadImg } from '@/utils/tools'
import { decryptData } from '@/utils/psd'
export default {
    data() {
        return {
            fabricCanvas: null,
            canvas: null,
            scale: 1,
            psdWidth: 1000,
            psdHeight: 1000,
            width: 500,
            height: 500,
            layerData: [],
            imgObject: {},
            faceArr: [],
            selectedFace: [],
            effectArr: [],
            effectCanvas: [],
            loading: false,
            loadingText: '渲染中',
            bmList: {
                'normal': 'source-over',
                'pass through': 'source-over',
                'multiply': 'multiply',
                'soft light': 'soft-light',
                'linear burn': 'color-burn'
            },
        };
    },

    methods: {
        loadImage(file) {
            const reader = new FileReader();
            reader.readAsDataURL(file.file);
            reader.onload = () => {
                this.setMap(reader.result);
            }
        },
        resetPage() {
            this.layerData = [];
            this.imgObject = {};
            this.faceArr = [];
            this.selectedFace = [];
            this.effectCanvas[0] = null;
            this.fabricCanvas.getObjects().forEach(obj => {
                this.fabricCanvas.remove(obj);
            });
        },
        async loadPsd(psd) {
            try {
                await this.buildPsdValue(psd.psdDatas);
                this.layerData = psd.psdDatas;
                const maxSide = Math.max(psd.width, psd.height);
                this.psdWidth = psd.width;
                this.psdHeight = psd.height;
                const scale = 500 / maxSide;
                this.effectArr = [{
                    scaleX: scale,
                    scaleY: scale,
                    left: (500 - psd.width * scale) / 2,
                    top: (500 - psd.height * scale) / 2
                }];
                await this.$nextTick();
                this.effectCanvas[0] = new fabric.Canvas('effectCanvas-0', {
                    fireRightClick: true,
                    stopContextMenu: true,
                    controlsAboveOverlay: true,
                    imageSmoothingEnabled: false,
                    centeredRotation: true,
                    preserveObjectStacking: true,
                    selection: false,
                    backgroundColor: '',
                    width: psd.width,
                    height: psd.height
                });
                await this.drawAllLayers(true);
            } catch (error) {
                console.log(error)
            }
        },


        buildPsdValue(value) {
            for (const layer of value) {
                if (layer.T === 'Group' || layer.T === 'SmartObject') {
                    this.faceArr.push(layer);
                }
                if (layer.IMG) {
                    this.imgObject[layer.N] = layer.IMG;
                } else if (layer.CL) {
                    const imgChild = layer.CL.find(c => c.IMG);
                    if (imgChild) this.imgObject[layer.N] = imgChild.IMG;
                }
            }
        },



        async drawAllLayers() {
            for (let item of this.layerData) {
                await this.drawCanvas(item)
            }
        },



        async drawCanvas(item) {
            try {
                const canvas = this.effectCanvas[0];
                const layers = item.T === 'Group' ? item.CL || [] : [item];
                const fabricObjs = [];
                for (const layer of layers) {
                    const name = layer.T === 'SmartObject' ? item.N : layer.N;
                    if (this.imgObject[name]) {
                        const PATH = item.MK?.path || '';
                        const { X, Y, O } = layer;
                        const blendMode = this.bmList[layer.BM] || 'source-over';
                        const imgObj = await new Promise((resolve, reject) => {
                            fabric.Image.fromURL(
                                this.imgObject[name],
                                (img) => {
                                    img.name = name
                                    resolve(img)
                                },
                                { crossOrigin: 'anonymous' }
                            );
                        });

                        imgObj.set({
                            selectable: false,
                            left: X,
                            top: Y,
                            opacity: O,
                            globalCompositeOperation: blendMode,
                            hasControls: false,
                            hasBorders: false,
                        });
                        if (PATH) {
                            const clipPath = new fabric.Path(PATH, {
                                fill: 'transparent',
                                objectCaching: false,
                                absolutePositioned: true,
                            });
                            const { left, top } = clipPath.getBoundingRect();
                            clipPath.set({
                                left: item.MK.left + left,
                                top: item.MK.top + top,
                            })
                            imgObj.clipPath = clipPath;
                        }
                        fabricObjs.push(imgObj);
                    }
                }
                // 一次性添加并统一渲染
                canvas.add(...fabricObjs).renderAll();
            } catch (error) {
                console.error('绘制画布时出错:', error);
                return false;
            }
        },



        setMap(file) {
            if (this.selectedFace.length == 0) {
                this.$message({
                    message: '请先选择定制面',
                    type: 'warning',
                })
                return
            }
            fabric.Image.fromURL(
                file,
                (img) => {
                    img.scaleToHeight(500);
                    this.fabricCanvas.add(img);
                },
                {
                    crossOrigin: "anonymous",
                }
            );
        },

        async createTextureByFace(layer, name) {
            try {
                const value = layer.CL ? layer.CL.find((i) => i.T == 'SmartObject') : layer
                const OS = value.OS
                let width = this.fabricCanvas.width
                let height = this.fabricCanvas.height
                let scale = 1
                if (OS[0] > OS[1]) { // 宽度大于高度
                    scale = OS[1] / this.fabricCanvas.width
                    width = height * OS[0] / OS[1]
                } else {
                    scale = OS[0] / this.fabricCanvas.width
                    height = width * OS[1] / OS[0]
                }
                const canvas = document.createElement('canvas')
                canvas.width = width * scale
                canvas.height = height * scale
                const ctx = canvas.getContext('2d')
                ctx.fillStyle = 'transparent'
                ctx.fillRect(0, 0, canvas.width, canvas.height)
                const left = (canvas.width - this.fabricCanvas.height * scale) / 2
                const top = (canvas.height - this.fabricCanvas.width * scale) / 2
                let texture = this.fabricCanvas.toDataURL({
                    format: 'png',
                    quality: 1,
                    multiplier: scale,
                });
                let images = await loadImg(texture)
                ctx.drawImage(images, left, top)
                let img = canvas.toDataURL()
                canvas.remove()
                if (value.M) {
                    const render = new SmartObjectRenderer({ size: value.WT, bg_img: value.IMG })
                    const glCanvasImg = await render.setTexture({ imageUrl: img, meshPoints: value.PS, customMatrix: value.M, width: value.OS[0], height: value.OS[1] })
                    this.replaceImage(name, glCanvasImg)
                } else {
                    this.replaceImage(name, img)
                }
                return
            } catch (error) {
                console.error("创建纹理时出错:", error);
                throw error;
            }
        },

        async refreshTexture() {
            this.loading = true
            const promises = []
            for (let name of this.selectedFace) {
                const item = this.faceArr.find((i) => i.N == name)
                promises.push(this.createTextureByFace(item, name))
            }
            await Promise.all(promises)
            this.loading = false
        },


        replaceImage(name, url) {
            const canvas = this.effectCanvas[0];
            const obj = canvas.getObjects().find((i) => i.name == name)
            const layer = this.layerData.find((i) => i.N == name)?.CL ? this.layerData.find((i) => i.N == name)?.CL.find((i) => i.T == 'SmartObject') : this.layerData.find((i) => i.N == name)
            if (!obj || !layer) {
                console.error(`未找到对象或图层: ${name}`);
                return;
            }

            obj.setSrc(
                url,
                (imgObj) => {
                    canvas.setActiveObject(imgObj).renderAll()
                }, {
                crossOrigin: 'anonymous'
            })
        },

    },

    async mounted() {

        this.fabricCanvas = new fabric.Canvas("canvas-editor", {
            fireRightClick: true,
            stopContextMenu: true,
            controlsAboveOverlay: true,
            imageSmoothingEnabled: false,
            centeredRotation: true,
            preserveObjectStacking: true,
            selection: false,
            backgroundColor: "",
            width: 500,
            height: 500,
        });
        this.fabricCanvas.on("object:modified", this.refreshTexture);
        this.fabricCanvas.on("object:added", this.refreshTexture);
        let psd = await decryptData(this.$route.query.psd)
        await this.$nextTick()
        this.loadPsd(psd)

    },
};
</script>
<style lang="scss">
.flex {
    display: flex;
}
</style>